import React from "react";
import { View, Text, Image, TouchableOpacity, Platform, StyleSheet } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";
import ProfileEditImage from "./ProfileEditImage";
import smile from "components/assets/grey_smile.png";

// phone (###) ###-#### format //{profile.phone_1 || "--"} //old
const formatPhoneNumber = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith("1")) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone || "--";
};

const ProfileDetails = ({ profile, imageUrl, theme, onEdit, onImageChange }) => {
  const profile_imageUrl = imageUrl || smile;

  return (
    <View>
      <View style={{ flexDirection: "row", alignItems: "flex-start", marginBottom: 18, width: "100%" }}>
        <ProfileEditImage imageUrl={profile_imageUrl} editable onImageChange={onImageChange} size={72} />
        <View style={{marginLeft:20,flex:1,flexDirection:"row",alignItems:"flex-start",justifyContent:"space-between"}}>
          <Text style={{...theme.pageTitleText,fontWeight:"bold",fontSize:22,flex:1,marginRight:12}} numberOfLines={2} ellipsizeMode="tail">
            {`${profile.first_name || ""} ${profile.last_name || ""}`.trim() || "Guest Account"}
          </Text>
          <TouchableOpacity style={{padding:4}} onPress={onEdit}>
            <Feather name="edit-2" size={20} color={theme.colors.mode.textColor} />
          </TouchableOpacity>
        </View>
      </View>

      {/* Details */}
      <View style={{ marginBottom: 16 }}>
        <Text style={theme.normalText}>
          <Text style={{fontWeight:"bold"}}>First Name:</Text>{" "}
          {profile.first_name || "--"}
        </Text>
      </View>
      <View style={{ marginBottom: 16 }}>
        <Text style={theme.normalText}>
          <Text style={{fontWeight:"bold"}}>Last Name:</Text>{" "}
          {profile.last_name || "--"}
        </Text>
      </View>
      <View style={{ marginBottom: 16 }}>
        <Text style={theme.normalText}>
          <Text style={{fontWeight:"bold"}}>Email:</Text>{" "}
          {profile.email_1 || "--"}
        </Text>
      </View>
      <View style={{ marginBottom: 16 }}>
        <Text style={theme.normalText}>
          <Text style={{fontWeight:"bold"}}>Phone:</Text>{" "}
          {formatPhoneNumber(profile.phone_1) || "--"}
        </Text>
      </View>
    </View>
  );
};

export default ProfileDetails;
